namespace Matrix.Exceptions {
    export class ExceptionLinkColumns {
        static columnsKey = 'Exceptions.ExceptionLink';
    }
}
